export default {
  getActiveEntities(state) {
    return state.entities.filter((entity) => entity.deleted_at === null)
  },
  activeEntityCount(state, getters) {
    return getters.getActiveEntities.length
  },
}
